import { render, staticRenderFns } from "./tuijian-reci.vue?vue&type=template&id=10168cf0&"
import script from "./tuijian-reci.vue?vue&type=script&lang=js&"
export * from "./tuijian-reci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports